// ─── Shared yield / benchmark constants ───

export const YIELD_DATA = {
  Kenya: [
    { instrument: '91-day T-bill', frontierYield: 8.8 },
    { instrument: '182-day T-bill', frontierYield: 9.2 },
    { instrument: '364-day T-bill', frontierYield: 10.1 },
  ],
  India: [
    { instrument: '91-day T-bill', frontierYield: 6.8 },
    { instrument: '182-day T-bill', frontierYield: 6.9 },
    { instrument: '364-day T-bill', frontierYield: 7.0 },
  ],
  Brazil: [
    { instrument: '91-day T-bill', frontierYield: 13.25 },
    { instrument: '182-day T-bill', frontierYield: 13.5 },
    { instrument: '364-day T-bill', frontierYield: 13.75 },
  ],
  Mexico: [
    { instrument: '91-day T-bill', frontierYield: 11.0 },
    { instrument: '182-day T-bill', frontierYield: 11.2 },
    { instrument: '364-day T-bill', frontierYield: 11.5 },
  ],
  Turkey: [
    { instrument: '91-day T-bill', frontierYield: 45.0 },
    { instrument: '182-day T-bill', frontierYield: 43.0 },
    { instrument: '364-day T-bill', frontierYield: 40.0 },
  ],
  Bangladesh: [
    { instrument: '91-day T-bill', frontierYield: 8.5 },
    { instrument: '182-day T-bill', frontierYield: 9.0 },
    { instrument: '364-day T-bill', frontierYield: 9.5 },
  ],
  'South Africa': [
    { instrument: '91-day T-bill', frontierYield: 7.5 },
    { instrument: '182-day T-bill', frontierYield: 8.0 },
    { instrument: '364-day T-bill', frontierYield: 8.5 },
  ],
  Egypt: [
    { instrument: '91-day T-bill', frontierYield: 25.5 },
    { instrument: '182-day T-bill', frontierYield: 26.0 },
    { instrument: '364-day T-bill', frontierYield: 26.5 },
  ],
  Ethiopia: [
    { instrument: '91-day T-bill', frontierYield: 14.0 },
    { instrument: '182-day T-bill', frontierYield: 14.5 },
    { instrument: '364-day T-bill', frontierYield: 15.0 },
  ],
};

export const BENCHMARK_RATES = { USD: 4.5, CHF: 1.5, AED: 5.0, GBP: 4.5, JPY: 0.5 };

export const SOURCE_LABELS = {
  USD: 'US Treasury',
  CHF: 'Swiss Govt',
  AED: 'UAE Govt',
  GBP: 'UK Gilt',
  JPY: 'Japan Govt (JGB)',
};

export const FF_FEE = 1.5; // Forwardsflow fee %

export const CURRENCY_SYMBOLS = { USD: '$', GBP: '£', CHF: 'CHF ', AED: 'AED ', JPY: '¥' };
